export default __webpack_public_path__ + "static/media/Scenarios-Background3.bbd62dae.jpeg";